/**
 * Nicha — menu Femme / Womenswear : liens en gras épais
 * FR : Voir tout + Prêt à partir | EN : View all + Ready to go
 * BUILD: 2026-06-18-menu-femme-v5
 */
(function () {
  'use strict';

  const normalizeHref = (href) => {
    if (!href) return '';
    try {
      const path = new URL(href, window.location.origin).pathname;
      return path.replace(/\/$/, '').toLowerCase();
    } catch {
      return href.split('?')[0].replace(/\/$/, '').toLowerCase();
    }
  };

  const normalizeMenuLabel = (text) =>
    (text || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/-/g, ' ');

  const isWomenswearBoldHref = (href) => {
    const path = normalizeHref(href);
    if (path.endsWith('/collections/premiere-vague') || path.endsWith('/collections/first-wave-01')) {
      return true;
    }
    if (path.endsWith('/collections/pret-a-partir') && !path.includes('homme')) {
      return true;
    }
    if (path.endsWith('/collections/ready-to-go-womenswear')) {
      return true;
    }
    return false;
  };

  const isWomenswearBoldLabel = (text) => {
    const label = normalizeMenuLabel(text);
    return (
      label === 'voir tout' ||
      label === 'view all' ||
      label === 'pret a partir' ||
      label === 'ready to go'
    );
  };

  const applyWomenswearMenuBold = () => {
    document
      .querySelectorAll(
        '.header a.header__menu-item, .header .mega-menu__link, .menu-drawer a.menu-drawer__menu-item, .menu-drawer .menu-drawer__menu a'
      )
      .forEach((link) => {
        const href = link.getAttribute('href') || '';
        const label = link.textContent || '';
        if (!isWomenswearBoldHref(href) && !isWomenswearBoldLabel(label)) return;
        if (href.includes('ready-to-go-menswear') || href.includes('pret-a-partir-homme')) return;

        link.classList.add('nicha-menu-femme-bold');
        link.style.setProperty('font-weight', '800', 'important');
        link.style.setProperty('letter-spacing', '0.02em', 'important');
      });
  };

  const init = () => {
    applyWomenswearMenuBold();
    [200, 800, 2000, 4000].forEach((delay) => setTimeout(applyWomenswearMenuBold, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
